import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
  Tooltip,
  Box,
  Zoom,
} from "@mui/material";
import React from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function EmployeeSelect(props) {
  const options = props.input.employees;

  const handlePick = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      props.setInput({
        ...props.input,
        selEmployees:
          props.input.selEmployees.length === options.length ? [] : options,
      });
      return;
    }
    props.setInput({ ...props.input, selEmployees: value });
  };

  return (
    <FormControl>
      <InputLabel id="label">Nomi partecipanti</InputLabel>
      <Select
        id="select"
        labelId="label"
        label="Nomi partecipanti"
        multiple
        value={props.input.selEmployees}
        onChange={handlePick}
        renderValue={(selected) => {
          const str = selected.length > 1 ? ", +" + (selected.length - 1) : "";
          return (
            <Tooltip
              TransitionComponent={Zoom}
              title={selected
                .map((e) => `${e.firstName} ${e.lastName}`)
                .join(", ")}
              disableInteractive
            >
              <Box>
                {`${selected[0].firstName} ${selected[0].lastName}` + str}
              </Box>
            </Tooltip>
          );
        }}
        MenuProps={MenuProps}
      >
        <MenuItem value="all">
          <ListItemIcon>
            <Checkbox
              id="all"
              checked={
                options.length > 0 &&
                props.input.selEmployees.length === options.length
              }
              indeterminate={
                props.input.selEmployees.length > 0 &&
                props.input.selEmployees.length < options.length
              }
            />
          </ListItemIcon>
          <ListItemText primary="Seleziona tutti" />
        </MenuItem>

        {options.length > 0 ? (
          options.map((employee) => (
            <MenuItem
              key={`${employee.firstName} ${employee.lastName}`}
              value={employee}
            >
              <ListItemIcon>
                <Checkbox
                  id={`${employee.firstName} ${employee.lastName}`}
                  checked={props.input.selEmployees.includes(employee)}
                />
              </ListItemIcon>
              <ListItemText
                primary={`${employee.firstName} ${employee.lastName}`}
              />
            </MenuItem>
          ))
        ) : (
          <div></div>
        )}
      </Select>
    </FormControl>
  );
}

export default EmployeeSelect;
